<template>
  <div class="info">
    <HomePic/>
    <BreadNav/>
    <div class="sub-main">
<!--      <div class="left">-->
<!--        <LeftMenu/>-->
<!--      </div>-->
      <div class="right">
        <NewsList
                  :show-page="true"
                  :show-search="false"
                  :showTitle="false">

        </NewsList>
      </div>
    </div>
  </div>
</template>

<style lang="less">
</style>

<script>
import HomePic from '@/components/style1/HomePic.vue';
import BreadNav from '@/components/style1/BreadNav.vue';
import NewsList from '@/components/style1/NewsList.vue';

export default {
  name: 'Info',
  components: {
    HomePic, BreadNav, NewsList,
  },
  computed: {
    keyword() {
      return this.$store.state.keyword;
    },
  },
};
</script>
